<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md4>
        <v-card color="purple" dark>
          <v-card-title primary class="title">Lorem</v-card-title>
          <v-card-text>{{ lorem }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-layout row wrap>
          <v-flex d-flex>
            <v-card color="indigo" dark>
              <v-card-text>{{ lorem.slice(0, 70) }}</v-card-text>
            </v-card>
          </v-flex>
          <v-flex d-flex>
            <v-layout row wrap>
              <v-flex v-for="n in 2" :key="n" d-flex xs12>
                <v-card color="red lighten-2" dark>
                  <v-card-text>{{ lorem.slice(0, 40) }}</v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex xs12 sm6 md2 child-flex>
        <v-card color="green lighten-2" dark>
          <v-card-text>{{ lorem.slice(0, 90) }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-card color="blue lighten-2" dark>
          <v-card-text>{{ lorem.slice(0, 100) }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-data-table
          options.sync="pagination"
          :footer-props="{ 'items-per-page-options': rowsPerPageItems }"
          :headers="headers"
          :items="topics"
          :server-items-length="totalTopics"
          :loading="loading"
          item-key="id"
          must-sort
          class="elevation-1 full-width full-height"
        >
          <v-progress-linear v-slot:progress color="blue" indeterminate />
          <template slot="items" slot-scope="props">
            <td class="text-center">{{ props.item.name_th }}</td>
            <td class="text-center">{{ props.item.name_en }}</td>
            <td class="text-center">{{ capitalize(props.item.type) }}</td>
            <td class="px-0 py-1">
              <v-flex align-center justify-center layout text-center>
                <v-icon :color="props.item.approved ? 'success' : 'grey'">
                  {{ props.item.approved ? 'check_box' : 'check_box_outline_blank' }}</v-icon
                >
              </v-flex>
            </td>
            <td class="px-0 py-1">
              <v-flex align-center justify-center layout text-center>
                <v-menu open-on-hover auto offset-y>
                  <v-btn slot="activator" color="secondary"> Action </v-btn>
                  <v-list>
                    <template v-if="!props.item.approved">
                      <v-list-item @click="(dialogEdit = true), setSelectTopic(props.item)">
                        <v-list-item-title>Approve</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="rejectTopic(props.item)">
                        <v-list-item-title>Reject</v-list-item-title>
                      </v-list-item>
                    </template>
                    <v-list-item v-if="props.item.approved" @click="(dialogEdit = true), setSelectTopic(props.item)">
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="(dialogMerge = true), setSelectTopic(props.item)">
                      <v-list-item-title>Merge</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-flex>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<script>
import { Vue } from 'vue-property-decorator';
// import userTransformer from "../transformers/user";
// import loader from "../utils/loader";
import store from '../store';
import Footer from '../components/Footer.vue';

export default Vue.extend({
  store,
  data: () => ({
    lorem:
      'Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.',
  }),
  computed: {
    user() {
      return store.state.auth.user;
    },
  },
  created() {},
  mounted() {},
  methods: {},
  components: {
    Footer,
  },
});
</script>
